// extracted by mini-css-extract-plugin
export default {"questions":"ContextQuestions_questions__WvpPd","completed":"ContextQuestions_completed__CbzjY","completedh4":"ContextQuestions_completedh4__O4VLc"};